import { SHOW_MESSAGE } from './mutation-types'

export function showMessage ({ commit }, params) {
  commit(SHOW_MESSAGE, {
    type: params[0],
    text: params.length > 1 ? params[1] : '',
    text2: params.length > 2 ? params[2] : '',
  })
}
